// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalBody {
    background: #252525;
    padding: 20px 30px;
    border-radius: 20px;
}
.modalBody h1 {
    color: white;
    width: 100%;
    font-weight: 600;
    text-align: left;
}

.modalBody h5{
    color: white;
    width: 100%;
    margin-bottom: 5px;
}
.modal-content {
    border-radius: 40px;
    top: 65px;
}

.imgContainer {
    text-align: center;
    width: 100%;
    margin-bottom: 15px;
}
.imgContainer img {
    width: 85%;
    margin: 0px auto;
    text-align: center;
}
.buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin-top: 20px
}

.buttonModal {
    background: var(--color1Ink);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 125px;
    height: 45px;
    color: white;
    font-size: 1.3rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-radius: 25px;
    border: none;
    padding: 15px;
}
.buttonModalNeg {
    background: white;
    color: var(--color1Ink);
    border: 3px solid var(--color1Ink);
}
@media (max-width:556px) {


    .modal-content {
        border-radius: 30px !important;
        margin-top: 50px;

    }
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ModalYesNo.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;;;IAGI;QACI,8BAA8B;QAC9B,gBAAgB;;IAEpB;AACJ","sourcesContent":[".modalBody {\n    background: #252525;\n    padding: 20px 30px;\n    border-radius: 20px;\n}\n.modalBody h1 {\n    color: white;\n    width: 100%;\n    font-weight: 600;\n    text-align: left;\n}\n\n.modalBody h5{\n    color: white;\n    width: 100%;\n    margin-bottom: 5px;\n}\n.modal-content {\n    border-radius: 40px;\n    top: 65px;\n}\n\n.imgContainer {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 15px;\n}\n.imgContainer img {\n    width: 85%;\n    margin: 0px auto;\n    text-align: center;\n}\n.buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n    margin-top: 20px\n}\n\n.buttonModal {\n    background: var(--color1Ink);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 125px;\n    height: 45px;\n    color: white;\n    font-size: 1.3rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    border-radius: 25px;\n    border: none;\n    padding: 15px;\n}\n.buttonModalNeg {\n    background: white;\n    color: var(--color1Ink);\n    border: 3px solid var(--color1Ink);\n}\n@media (max-width:556px) {\n\n\n    .modal-content {\n        border-radius: 30px !important;\n        margin-top: 50px;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
